<script setup lang="ts">
import { NScrollbar } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  trigger?: 'none' | 'hover' | 'always'
  xScrollable?: boolean
  yScrollable?: boolean
  size?: number
  duration?: number
  onScroll?: (e: Event) => void
  onWheel?: (e: WheelEvent) => void
  onTouchstart?: (e: TouchEvent) => void
  onTouchmove?: (e: TouchEvent) => void
  onTouchend?: (e: TouchEvent) => void
}>(), {
  trigger: 'hover',
  xScrollable: true,
  yScrollable: true,
  size: 12,
  duration: 300,
})

const emit = defineEmits<{
  'scroll': [e: Event]
  'wheel': [e: WheelEvent]
  'touchstart': [e: TouchEvent]
  'touchmove': [e: TouchEvent]
  'touchend': [e: TouchEvent]
}>()

const attrs = useAttrs()

const onScroll = (e: Event) => {
  emit('scroll', e)
}

const onWheel = (e: WheelEvent) => {
  emit('wheel', e)
}

const onTouchstart = (e: TouchEvent) => {
  emit('touchstart', e)
}

const onTouchmove = (e: TouchEvent) => {
  emit('touchmove', e)
}

const onTouchend = (e: TouchEvent) => {
  emit('touchend', e)
}
</script>

<template>
  <NScrollbar
    :trigger="trigger"
    :x-scrollable="xScrollable"
    :y-scrollable="yScrollable"
    :size="size"
    :duration="duration"
    v-bind="attrs"
    @scroll="onScroll"
    @wheel="onWheel"
    @touchstart="onTouchstart"
    @touchmove="onTouchmove"
    @touchend="onTouchend"
  >
    <slot />
  </NScrollbar>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
